"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { ProductImage } from "../../../ProductImage/index.js";
import { ProductSwatch } from "../../../ProductSwatch/index.js";
import { useProductTileData } from "../../../../../hooks/useProductTileData/index.js";
import { imageStyles, childElementStyles } from "./styles.js";
const ImageSwatchBlock = ({
  colorSwatchesData,
  isHorizontal,
  maxImageHeight,
  minProductTileImageWidth,
  maxProductTileImageWidth,
  onRemovePreview,
  onPreviewImageUrl,
  onSwatchClick,
  onSwatchPreview,
  partNumber,
  productName,
  productTitleId,
  translations,
  imageUrl
}) => {
  var _a;
  const { isInformative } = useProductTileData();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      ProductImage,
      {
        sx: {
          ...imageStyles,
          marginBottom: isHorizontal ? 0 : (_a = imageStyles) == null ? void 0 : _a.marginBottom,
          marginRight: isHorizontal ? SpaceXs : 0,
          maxHeight: maxImageHeight,
          minWidth: !isHorizontal ? minProductTileImageWidth : void 0,
          maxWidth: !isHorizontal ? maxProductTileImageWidth : void 0
        },
        ariaHidden: true,
        src: onPreviewImageUrl || imageUrl || "",
        srcFallback: (translations == null ? void 0 : translations.noimgurl) || "",
        title: productName || "",
        titleFallback: (translations == null ? void 0 : translations.noimgtext) || "",
        uniqueId: partNumber
      }
    ),
    colorSwatchesData && colorSwatchesData.length > 1 && isInformative && /* @__PURE__ */ jsx(
      ProductSwatch,
      {
        sx: {
          ...childElementStyles,
          alignItems: "flex-start",
          display: "flex",
          justifyContent: "center"
        },
        ariaDescribedBy: productTitleId,
        onPreview: onSwatchPreview,
        onRemovePreview,
        onSelect: onSwatchClick,
        showLabel: true,
        swatches: colorSwatchesData,
        uniqueId: partNumber,
        variant: "compact"
      }
    )
  ] });
};
export {
  ImageSwatchBlock
};
